module.exports = __webpack_public_path__ + "img/zoom-in-active.5550339b.svg";